<template>
	<div class="container">
		<top :currentComponent="currentComponent" @Select="Select" :topList="topList"></top>
        <div style="margin-bottom: 0.33rem;">
          <clientTop @ActivityDetail="ActivityDetail"></clientTop>    
        </div>
		<component :is="currentComponent"></component>
	</div>
</template>
<script>
	import top from "@/views/mechanism/children/top";
    import clientTop from './components/clientAnddistributionChild/clientTop'
    import allClient from './components/clientAnddistributionChild/allClient'
    import clientFission from './components/clientAnddistributionChild/clientFission'
    import addActivity from './components/clientAnddistributionChild/addActivity'
	export default {
		components: {
			top,
            clientTop,
            allClient,
            clientFission,
            addActivity
		},
		data() {
			return {
				topList: [{
						name: "全部客户",
						to: "allClient",
					},
					{
						name: "客户裂变",
						to: "clientFission",
					},
					{
						name: "我的会员",
						to: "暂无页面",
					},
				],
					currentComponent:'allClient',
				}
			},
			methods:{
				Select(val) {
					this.currentComponent = val
				},
                //查看活动详情
                ActivityDetail() {
                    this.currentComponent = 'addActivity'
                }
			},
			mounted() {
				let data = this.$route.query
				if(JSON.stringify(data) !== '{}') {
					 this.currentComponent = data.currentComponent
				}
			},
		}
</script>

<style lang="scss" scoped>
	.container {
		height: 8rem;
		width: 100%;
        background-color: #E8E8E7;
	}
</style>
